
import Velas from "../../../assets/outline/Velas.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VelasIcon({ className, dataTestid = "VelasIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Velas data-testid={dataTestid} className={classes} {...rest} />
  );
}
